<template>
  <div>
    <prohead></prohead>
    <div style="width:100%;margin: auto">
      <div class="banner" style="background: url('../../static/img/c_banner.png');position: relative">

        <div style="position: absolute;left: 43%"> 玩の国 乐の芯</div>
      </div>

      <div  id="fzlc" style="text-align: center;">
      <div>
<!--        <ul class="tab-title">-->
<!--          <li v-for="(title,index) in tabTitle" @click="cur=index" :class="{active:cur==index}">{{title}}</li>-->
<!--        </ul>-->
      </div>
        <div class="box5_banner" style="margin-top: 40px;" >

          <div>
            <ul class="tab-title">
              <li v-for="(title,index) in tabTitle" @click="showPhoto(title.id,title.cate_name)" :class="{active:cur==title.cate_name}">{{title.cate_name}}</li>
            </ul>
          </div>
          <div class="tab-content" style="display: flex;flex-direction:row;flex-wrap: wrap">
              <div class="solution" style="margin-right: 8px" v-for="(m,index) in data"  @click="details(m.id,m.cate_name)">
                <div class="media-img margin-large-bottom">
                  <div style="overflow: hidden; height: 300px;width: 640px;line-height: 185px;text-align: center;margin: auto;border-radius: 10px;">
                    <img :src="m.prd_imgurl" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
                  <div class="linear-link" style="border-radius: 10px;background: rgb(214, 129, 100,0.9)">
                    <div class="subtitle">
                      <p class="text-white text-middle margin-small-bottom">{{m.prd_name}}</p>
                      <p class="text-white"></p>
                    </div>
                  </div>
                </div>
                <div style="width:100%;height:50px;"></div>

              </div>
          </div>
          <el-pagination
            style="margin-bottom: 20px"
            v-if="cur=='乐园图景'"
            background
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total">
          </el-pagination>
        </div>
<!--        <div class="chuang" id="ryzz" v-show="cur=='乐园图景'">-->
<!--          <div style="text-align: center">-->
<!--            <div class="titlebox" style="padding-top: 65px">创新融合主题式场景体验</div>-->
<!--            <p class="title_fu">experience</p>-->
<!--            <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">-->
<!--          </div>-->


<!--          <div>-->
<!--            <p>-->
<!--              开心玩国，站在更高的视点，更广阔的视角，本着尊重儿童的天性，探索儿童乐园需求的本质，为实现更好的，符合儿童身心愉悦发展规律的，真正受儿童喜爱的场所而设计表达。-->
<!--              坚守与创新，铸就了开心玩国非凡的内核。坚守为孩子的初心，助力成长成就未来。同时，用创新的理念与工匠的精神，在儿童乐园及其相关产品方面的设计、研发、生产等各个环节与细节成-->
<!--              就卓越。-->
<!--              <br>-->
<!--              一个更具文化内涵、更有故事性、主题更加突出、设计更具特色、玩乐参与性和体验性更强的场景化沉浸式的儿童乐园+应运而生。-->
<!--              这一强势升级，为开心玩国品牌赋予了更与时俱进的价值观和生命力。-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->

      </div>

    </div>

    <Profooter></Profooter>
  </div>

</template>

<script>
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
export default {
  name: "index",
  components: {Prohead,Profooter},
  data() {
    return {
      url:'http://api.kxwg123.com /',
      tabTitle: [

      ],
      cur: '六大主题',
      activeName:'first',
      data:[],
      total: '',
      listQuery: {
        page: 1,
        limit: 10,
      },
    }
  },
  watch: {
    $route(to, from) {
      console.log('lalala', this.$route.query.id)
      if (this.$route.query.id == undefined) {
        this.cur = '六大主题'
      } else {
        if (this.$route.query.id) {
          console.log('12131231', this.$route.query.id)

          this.cur  = this.$route.query.id
          console.log('8888888888888888',this.cur)
        }
      }

    }
  },
  created() {
    this.cur = '六大主题'
    this.showPhoto(3,this.cur)
    this.shoo()
  },
  mounted() {


  },
  methods: {
    handleCurrentChange(val){
      console.log(val)
      this.listQuery.page = val
      this.showPhoto(6,this.cur)
    },
    details(id,name){
      this.$router.push('/prodetails?id='+id+'&name='+name)
    },
    showPhoto(cate_id,title){
      this.cur = title
      let formdata = new FormData()
      formdata.append('page',this.listQuery.page)
      formdata.append('limit',this.listQuery.limit)
      formdata.append('cate_id',cate_id)
      this.$axios.post('/index/Product/ProductList  ',formdata).then(res => {
        this.data = res.data.data
        this.total = res.data.total
      });
    },
    shoo(){
      let formdata = new FormData()
      formdata.append('page',this.listQuery.page)
      formdata.append('limit',this.listQuery.limit)
        this.$axios.post('/index/ProductCate/productCateList  ',formdata).then(res => {
        this.tabTitle = res.data.data
      });
    },

  }
}
</script>

<style scoped>
.contaniorn .img{
  margin-top: 50px !important;
}
.tab-title{
  width: 1300px;
  height: 100px;
}
.tab-title li:hover{
  cursor: pointer;
}
.tab-title li{
  width: 180px;
  height: 60px;
  border-radius: 30px;
  float: left;
  border: 1px solid #C5C5C5;
  line-height: 60px;
  text-align: center;
  margin-right: 20px;
  font-size: 18px;
}
.tab-title .active{
  background: #EA5C48;
  color: white;
  cursor: pointer;
  border: 1px solid #EA5C48;

}
.linear-link{
  position: absolute;
  bottom: 0;
  width: 640px;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 500;
  color: #FFFFFF;
  height: 50px;
  background: #D68164;
  opacity: 0.9;
  border-radius: 10px !important;
  line-height: 50px;
}
.solution {
  margin-bottom: 10px;
}
.solution:hover{
  cursor: pointer;
}
.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.box6_div:hover{
  background: rgb(234, 92, 72,0.5)
}
.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.solution .media-img .mask {
  opacity: 0;
  z-index: 3;
  background: rgb(40 167 225 / 85%);
  width: 92%;
  height: 92%;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  transition: 0.3s;
  margin-left: 11px;
  margin-top: 12px;
}
.solution .media-img {
  position: relative;
  width: 640px;
  height: 300px;
}
.solution .media-img .mask .subtitle {
  padding: 17px;
  color: #ffffff;
  text-align: left;
}
.box6{
  height: 600px;
//background: url("../../static/img/bg3.jpg");

}
.banner_pin div{
  float: left;
}
.box5{
  height:889px;
  text-align: center;
}
.box5_banner{
  width:1300px;
  margin: 0 auto;
}
.box5_bannerimg{
  width: 640px;
  height: 300px;
  float: left;
  margin-right: 8px;
  margin-bottom: 8px;
  position: relative;
}
.box5_bannerimg div{
  width: 100%;
  height: 50px;
  background: #D68164;
  opacity: 0.9;
  border-radius: 10px;
  line-height: 50px;
  font-weight: 500;
  color: #FFFFFF;
  font-size: 20px;
  position: absolute;
  bottom: 0;
}
.box6_div:hover{
  background: rgb(234, 92, 72,0.5)
}
.box3{
  margin: 0 auto;
  width: 100%;

  height: 618px;
//background: url("../../static/img/bg2.jpg");
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  height: 894px;
  margin: 0 auto;
}
.chuang{
  width: 1300px;
  height: 420px;
  margin: 0 auto;
}
.chuang p{
  margin-top: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/le.vue